import React, { Fragment } from 'react';

// ponytail: the shared list's Search box pushes to /orders/search, which role 5
// has no route for. Dropped rather than shipped as a dead control.
const action = props => <Fragment />

export default action;
